import { COOKIE_NAMES } from '@libs/constants/constants';
import i18n from '@libs/i18n/I18n';
import { TOptions } from 'i18next';
import { deleteCookie, getCookie, setCookie } from './cookie';

import DOMPurify from 'dompurify';
import { marked } from 'marked';

export const PASSWORD_REGEX = /^(?=.*[A-Za-z])(?=.*d)[A-Za-zd]{8,}$/i;

export const hasNumber = (value: string): boolean => {
  return new RegExp(/[0-9]/).test(value);
};

export const hasMixed = (value: string): boolean => {
  return new RegExp(/[a-z]/).test(value) && new RegExp(/[A-Z]/).test(value);
};

export const hasSpecial = (value: string): boolean => {
  return new RegExp(/[!#@$%^&*)(+=._-]/).test(value);
};
export const strengthIndicator = (value: string): number => {
  let strengths = 0;
  if (value.length > 5) strengths += 1;
  if (value.length > 7) strengths += 1;
  if (hasNumber(value)) strengths += 1;
  if (hasSpecial(value)) strengths += 1;
  if (hasMixed(value)) strengths += 1;
  return strengths;
};

export const getRandomColor = (): string => {
  const colors = ['#233FD1', '#FFF4A8', '#9CD8C8', '#7087FF', '#8285D4'];
  return colors[Math.floor(Math.random() * colors.length)];
};

export const getRedirectToPath = (): string | null => getCookie(COOKIE_NAMES.REDIRECT_TO_PATH);

export const setRedirectToPath = (accessToken: string): void => {
  setCookie({ key: COOKIE_NAMES.REDIRECT_TO_PATH, value: accessToken, path: '/' });
};

export const removeRedirectToPath = (): void => {
  deleteCookie(COOKIE_NAMES.REDIRECT_TO_PATH);
};

export function translate(key: string, options?: TOptions): string {
  return i18n.t(key, options);
}

export function parseMDX(content: string): string {
  if (!content) return '';
  return DOMPurify.sanitize(marked.parse(content) as string);
}

export function formatErrorCode(error: string): string {
  if (error.startsWith('ERCTLNR')) {
    return `Something went wrong. Please try again later. [${error}]`;
  }
  return 'Something went wrong. Please try again later.';
}

export function decodeHTMLEntities(text: string): string {
  const parser = new DOMParser();
  const doc = parser.parseFromString(`<!doctype html><body>${text}`, 'text/html');
  return doc.body.textContent ?? '';
}
